<template>
  <NTF :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0"></NTF>
</template>

<script>
import NTF from "../../components/NTF-Stacked";

import { Chart } from "highcharts-vue";

export default {
  name: "dashboard",
  components: {
    NTF,
    highcharts: Chart
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
